export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getHouseList: function getHouseList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/get",
        method: "get",
        params: data
      });
    },
    getHouseInfo: function getHouseInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/getInfo",
        method: "get",
        params: data
      });
    },
    getHouseAuditCount: function getHouseAuditCount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/auditCount",
        method: "get",
        params: data
      });
    },
    getHouseFilterType: function getHouseFilterType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/filterType",
        method: "get",
        params: data
      });
    },
    // 更新房源
    updateHouse: function updateHouse() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/update",
        method: "post",
        data: data
      });
    },
    // 获取房源认证信息
    getHouseAuthInfo: function getHouseAuthInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/getAuthInfo",
        method: "get",
        params: data
      });
    },
    // 更新房源认证信息
    updateHouseAuthInfo: function updateHouseAuthInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/updateAuthInfo",
        method: "post",
        data: data
      });
    },
    // 更新实名认证信息
    updateRealNameAuthInfo: function updateRealNameAuthInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/updateRealNameAuthInfo",
        method: "post",
        data: data
      });
    },
    // 获取品牌季度房源
    getVipHouseList: function getVipHouseList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/getVipList",
        method: "get",
        params: data
      });
    },
    // 置顶房源
    stickHouse: function stickHouse() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/stick",
        method: "post",
        data: data
      });
    },
    // 删除房源
    deleteHouse: function deleteHouse() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/delete",
        method: "post",
        data: data
      });
    },
    // 打开房源
    operationOpenHouse: function operationOpenHouse() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/operationOpen",
        method: "post",
        data: data
      });
    },
    // 关闭房源
    operationCloseHouse: function operationCloseHouse() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/operationClose",
        method: "post",
        data: data
      });
    },
    // 实名认证
    operationRealNameAuth: function operationRealNameAuth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/auth",
        method: "post",
        data: data
      });
    },
    // 重新设置二房东认证
    operationAgainHouseAuth: function operationAgainHouseAuth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/againAuth",
        method: "post",
        data: data
      });
    },
    // 房源审核
    operationHouseAudit: function operationHouseAudit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/operationExamine",
        method: "post",
        data: data
      });
    },
    // 设置房源上线
    setHouseOnline: function setHouseOnline() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/setOnline",
        method: "post",
        data: data
      });
    },
    // 获取房源类型标签
    getHouseTypeTagList: function getHouseTypeTagList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/getTypeTagList",
        method: "get",
        params: data
      });
    },
    // 更新房源类型标签
    updateHouseTypeTagList: function updateHouseTypeTagList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/updateTag",
        method: "post",
        data: data
      });
    },
    // 发送房源通知
    sendHouseNotice: function sendHouseNotice() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/house/notice",
        method: "post",
        data: data
      });
    },
    // 设置房源认证状态
    setHouseAuthStatus: function setHouseAuthStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/house/set/need-auth",
        method: "post",
        data: data
      });
    },
    // 审核房源
    auditHouse: function auditHouse() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/house/audit",
        method: "post",
        data: data
      });
    },
    // 检测房源是否认证过
    checkHouseAuth: function checkHouseAuth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/house/auth/check",
        method: "post",
        data: data
      });
    },
    // 新增房东认证记录
    addLandlordAuth: function addLandlordAuth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/house_authentication/add_landlord_authentication",
        method: "post",
        data: data
      });
    },
    // 查询房东认证记录
    getLandlordAuthList: function getLandlordAuthList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/house_authentication/get_landlord_authentication_list",
        method: "get",
        params: data
      });
    },
    // 房东认证记录恢复
    restoreLandlordAuth: function restoreLandlordAuth() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/house_authentication/restore_landlord_authentication",
        method: "post",
        data: data
      });
    },
    // 获取房东等级评分
    queryUserScoreById: function queryUserScoreById() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/userScore",
        method: "post",
        data: data
      });
    },
    // 获取季度用户等级分
    queryQuarterScoreById: function queryQuarterScoreById() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/quarter/userScore",
        method: "post",
        data: data
      });
    },
    queryInfoByAI: function queryInfoByAI(house_id) {
      return request({
        url: "api/v1/admin/house/audit/info/llm",
        method: "get",
        params: {
          house_id: house_id
        }
      });
    },
    getHouseRecord: function getHouseRecord(house_id) {
      return request({
        url: "/api/v1/admin/house/update/record/get",
        method: "get",
        params: {
          house_id: house_id
        }
      });
    }
  };
});